import React, { useContext } from "react";

// Material UI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Global state
import { StateContext } from "../../AppStateContext";

// schema ad class state
import {
  SchemaAddClassStateContext,
  SchemaAddClassStateDispatchContext,
} from "./SchemaAddClassStateContext";

// Styling
import "./style.scss";

const AddClassFormClassName = () => {
  const state = useContext(StateContext);

  const schemaState = useContext(SchemaAddClassStateContext);
  const schemaSetState = useContext(SchemaAddClassStateDispatchContext);

  return (
    <div className="__schemaAddClassName">
      <label
        htmlFor="addClassNameInput"
        className={
          state.theme === "dark"
            ? "__addClassFormTextColorDark"
            : "__addClassFormTextColorLight"
        }
      >
        Name <span>*</span>
        <Tooltip
          placement="right-start"
          title=" The name of the class should be a descriptive, singular noun (e.g. Article, Product, Timezone) or verb (e.g. Buy, Eat, Pay). Keep in mind that additional validation might be applied depending on your (vectorization) module. A class name starts with a capital letter, and concatenated words are CamelCased (e.g. ArtStyle)."
        >
          <HelpIcon
            style={{
              fontSize: "13px",
              color: state.theme === "dark" ? "#848484" : "#5e5e5e",
              cursor: "pointer",
            }}
          />
        </Tooltip>
      </label>
      <small
        className={
          state.theme === "dark"
            ? "__addClassFormTextColorDark"
            : "__addClassFormTextColorLight"
        }
      >
        Camel cased, starting with capital letter
      </small>
      <input
        className={
          state.theme === "dark"
            ? "__addClassFormInputDark"
            : "__addClassFormInputLight"
        }
        required
        id="addClassNameInput"
        type="text"
        value={schemaState.class}
        onChange={(e) =>
          schemaSetState({ ...schemaState, class: e.target.value })
        }
      />
    </div>
  );
};

export default AddClassFormClassName;
